<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>工作台</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="navFrame">
      <div class="navDataBig">
        <div v-for="v in navList" :key="v.id" @click="noteTem(v.id)">
          <div>{{v.title}}</div>
          <div>
            <span>
              <span>{{v.navTotal}}</span>
              <span>{{v.unit}}</span>
            </span>
            <img :src="v.srcUrl" alt />
          </div>
        </div>
      </div>
    </div>
    <div class="wendang">
      <div>
        <div class="dang_title">
          <span>三方对接文档</span>
        </div>
        <div class="wen_boxs">
          <div>
            <a href="http://test.beebird.com.cn/doc/web/#/33?page_id=1401" target="_blank">
              <span>快手对接</span>
            </a>
            <span @click="kaitong">开通快手</span>
          </div>
          <div>
            <a href="http://test.beebird.com.cn/doc/web/#/33?page_id=1402" target="_blank">
              <span>抖音对接</span>
            </a>
            <span @click="kaitong">开通抖音</span>
          </div>
          <div>
            <a href="http://test.beebird.com.cn/doc/web/#/33?page_id=1404" target="_blank">
              <span>小红书对接</span>
            </a>
          </div>
          <div>
            <a href="http://test.beebird.com.cn/doc/web/#/33?page_id=738" target="_blank">
              <span>美团对接</span>
            </a>
          </div>
          <div>
            <a href="http://test.beebird.com.cn/doc/web/#/33?page_id=739" target="_blank">
              <span>携程对接</span>
            </a>
          </div>
          <div>
            <a href="http://test.beebird.com.cn/doc/web/#/33?page_id=740" target="_blank">
              <span>天时、票付通、自我游、同程对接</span>
            </a>
          </div>
          <div>
            <a href="http://test.beebird.com.cn/doc/web/#/33?page_id=1403" target="_blank">
              <span>联联周边游对接</span>
            </a>
          </div>
          <div>
            <a href="http://test.beebird.com.cn/doc/web/#/33?page_id=1405" target="_blank">
              <span>飞猪、驴妈妈对接</span>
            </a>
          </div>
          
        </div>
      </div>
      <div>
        <div>
          <div class="dang_title">
            <span>短信服务费</span>
            <span :class="scenicbalance<100?'reds':''" v-if="charge=='1'">余额：{{scenicbalance}} 元</span>
            <span  :class="flow?'reds':''"  v-if="charge=='2'">截止时间：{{scenicbalance}}</span>
          </div>
          <div class="dang_btns">
            <div @click="goRecharge">
              去充值
            </div>
          </div>
        </div>
        <div>
          <div class="dang_title">
            <span>在线客服</span>
          </div>
          <div class="dang_btns">
            <div @click="zixun">
              咨询
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <el-card class="card"> -->
    <div class="card">
      <div class="cardDiv">
        <div>
          <div>
            <span>消息</span>
            <span @click="whole" class="cssWhole">全部信息></span>
          </div>
          <ul v-for="v in ulNote" :key="v.id" class="ul" @click="infoFn(v)">
            <li>
              <div>
                <img
                  style="width:17px;height:15px;vertical-align: middle;"
                  src="../../images/scenic/wdxx.png"
                  alt
                  srcset
                  v-if="v.State=='1'"
                />
                <img
                  style="width:17px;height:15px;vertical-align: middle;"
                  src="../../images/scenic/ydxx.png"
                  alt
                  srcset
                  v-if="v.State=='2'"
                />
                <span>{{v.FromUserID=='0'?'金飞鹰系统':'系统'}}</span>
                <span>{{v.tip2}}</span>
                <span>{{v.MailContent}}</span>
              </div>
              <div>{{v.CreateTime}}</div>
            </li>
          </ul>
        </div>
        <div class="cardRight">
          
          <div >
            <div>验票 <span style="color:red;margin-left:1.6rem;font-size:1.4rem">注: 验票小程序账号密码与雪务通相同</span></div> 
            <div>
              <img src="@/assets/yanpiao.jpg" alt="">
            </div>
            <!-- <div>请输入验证码</div>
            <el-input placeholder="请输入验证码" v-model="code"></el-input>
            <el-button @click="detailFn">查询</el-button> -->
          </div>
        </div>
      </div>
    </div>
    <!-- </el-card> -->
    <!-- 订单详情弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      title="订单详情"
      :visible.sync="noteDialogVisible"
      :before-close="noteHandleClose"
      width="75.6%"
      center
    >
      <el-divider></el-divider>

      <el-form ref="form" :model="form">
        <div class="formItem">
          <el-form-item label="订单号:" class="three">
            <el-input v-model="noteList.OrderNumber" disabled placeholder="订单号"></el-input>
          </el-form-item>
          <el-form-item label="分销商:" class="three">
            <el-input v-model="noteList.Name" disabled placeholder="分销商"></el-input>
          </el-form-item>
          <el-form-item label="成交时间:" class="four">
            <el-input v-model="noteList.CreateTime" disabled placeholder="成交时间"></el-input>
          </el-form-item>
          <el-form-item label="订单总额:" class="four">
            <el-input v-model="price1" disabled placeholder="订单总额"></el-input>
          </el-form-item>
          <el-form-item label="验证码:" class="three">
            <el-input v-model="noteList.OrderCode" disabled placeholder="验证码"></el-input>
          </el-form-item>
        </div>
      </el-form>

      <el-table
        :data="order_detail"
        :header-cell-style="tableHeaderColor"
        :cell-style="cellStyle"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
          <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column prop="productname" label="产品名称"></el-table-column>
        <el-table-column prop="consumestate" label="购买数量">
          <template slot-scope="scope">
            <span>{{ noteList.Count }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="已兑数量">
          <template slot-scope="scope">
            <span>{{ noteList.UseCount }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="可用数量">
          <template slot-scope="scope">
            <span>{{ noteList.Count-noteList.CancleCount - noteList.UseCount }}</span>
          </template>
        </el-table-column>
        <el-table-column  label="有效期">
          <template slot-scope="scope">
            <span>{{ scope.row.consumebegindate }}-{{ scope.row.consumeenddate }}</span>
          </template>
        </el-table-column>
        <el-table-column label="验票数量">
          <template slot-scope="scope">
              <div class="ticket_input">
                <el-input v-model="scope.row.state"></el-input>
              </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="btns">
        <el-button @click="checkprint" >打印</el-button>
        <el-button class="btnL" @click="checkTicFn()">验票</el-button>
      </div>
    </el-dialog>
    <!-- 订单详情弹框结束 -->

    <!-- 小票预览弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      title="小票打印预览"
      :visible.sync="printDialogVisible"
      :before-close="printHandleClose"
      width="25.1%"
      center
    >
      
      <el-divider></el-divider>
        
      <div class="conentCenter"  id="nbprint">
        <div class="printContent" >
          <div>订单核销清单</div>
          <div>
            <div class="print_l">
              <span>购票时间：</span>
              <span>{{noteList.CreateTime}}</span>
            </div>
            <div  class="print_l">
              <span>订单号：</span>
              <span class="pro_order" style="color:#E74C3C;">{{noteList.OrderNumber}}</span>
            </div>
            <div  class="print_l">
              <span>分销商：</span>
              <span>{{noteList.Name}}</span>
            </div>
            <div class="print_ri" v-for="(item,index) in noteList.order_detail" :key="index">
              <div>
                <span>商品名称：</span>
                <span >{{item.OrderAll.productname}}</span>
              </div>
              <div>
                <span>本次兑换：</span>
                <span>{{noteList.UseCount}}</span>
              </div>
              <div>
                <span>购买数量：</span>
                <span>{{ noteList.Count }}</span>
              </div>
              <div>
                <span>剩余数量：</span>
                <span>{{noteList.Count - noteList.CancleCount - noteList.UseCount }}</span>
              </div>
              
              <div>
                <span>验证日期：</span>
                <span>{{noteList.UseTime }}</span>
              </div>
            </div>
            <div  class="print_l">
              <span>来源：</span>
              <span>金飞鹰雪务通</span>
            </div>
            <div  class="print_l">
              <span>签名：</span>
              <span></span>
            </div>
            <!-- <el-descriptions :column="1" colon> -->
              <!-- <el-descriptions-item label="验票时间">{{ noteList.CreateTime }}</el-descriptions-item>
              <el-descriptions-item label="订单号" class="order">{{ noteList.OrderNumber }}</el-descriptions-item>
              <el-descriptions-item label="分销商">{{ noteList.Name }}</el-descriptions-item>
              <el-descriptions-item label="商品名称"></el-descriptions-item>
              <el-descriptions-item label="本次兑换">苏州市</el-descriptions-item>
              <el-descriptions-item label="购买数量">{{ noteList.Count }}</el-descriptions-item>
              <el-descriptions-item label="剩余数量">{{ noteList.Count-noteList.CancleCount }}</el-descriptions-item>
              <el-descriptions-item label="验证日期">苏州市</el-descriptions-item>
              <el-descriptions-item label="来源">苏州市</el-descriptions-item>
              <el-descriptions-item label="签名">苏州市</el-descriptions-item> -->
            <!-- </el-descriptions> -->
          </div>
          <div>注意事项:(核销成功后,需在收银台交付押金)</div>
        </div>
      </div>
      <div class="btn">
        <el-button v-print="printOption">打印</el-button>
      </div>
     
    </el-dialog>
    <!-- 小票预览弹框结束 -->
    <el-dialog :close-on-click-modal="false"
      title="订单详情"
      :visible.sync="infoDialogVisible"
      :before-close="infoHandleClose"
      width="34%"
      center
    >
      <el-divider></el-divider>

      <el-form ref="form" :model="form" label-width="80px">
        <div class="formItems">
          <div class="itemOne">
            <el-form-item label="来自于:" class="three">
              <el-input v-model="form.name" placeholder="订单号"></el-input>
            </el-form-item>
            <el-form-item label="收件时间:" class="three">
              <el-date-picker v-model="form.value1" type="datetime" placeholder="选择日期时间"></el-date-picker>
            </el-form-item>
          </div>
          <el-form-item label="消息内容:" class="four">
            <el-input
              type="textarea"
              :autosize="{minRows:5,maxRows:7}"
              v-model="form.content"
              placeholder="消息内容"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item class="itemBtn">
            <el-button class="btnL" @click="checkTicFn()">确认</el-button>
          </el-form-item> -->
        </div>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false"
      title="系统通知"
      :visible.sync="noticeFlow"
      :before-close="noticeClose"
      width="30%"
      center
    >
      <el-divider></el-divider>
      <div class="noticeClass">
          <div>
              <span class="title">{{notice.title}}</span>
              <span class="time">{{notice.sendtime}}</span>
              <span class="zz">尊敬的用户您好：</span>
              <span class="con">{{notice.content}}</span>
                <div>
                  发布者：系统
                </div>
          </div>
          <div class="btns_not">
            <div @click="noticeClose">稍后通知</div>
            <div @click="noticeBtns">已知晓</div>
          </div>
      </div>
    </el-dialog>
    <!-- <div class="mask_boxs" v-if="flow1|| is_id==2||is_id==3">
        <div class="box_content">
            <div class="title_content">景区提示</div>
            <div class="box_content_title_box">
              您的景区已下线，请联系业务开通续费。联系电话是15611477385。请您尽快联系该电话进行续费操作，以便恢复景区的正常运营。
            </div>
            <div class="tbns" @click="toastClick">
              去充值
            </div>
        </div>
    </div> -->
    <el-dialog :close-on-click-modal="false"
      title="在线客服"
      :visible.sync="lineFlow"
      :before-close="lineClose"
      
      width="42%"
      center
    >
      <el-divider></el-divider>
      <div class="line_box">
        <div class="top" ref="dialogue">
          <div class="top_content" >
              <div class="top_left">
                <img src="@/assets/logo2.png" alt="">
                <div>
                  你好，我是金飞鹰雪务通客服小金，欢迎咨询...
                  <p v-for="(item,index) in list" :key="index" @click="listBtns(item)" v-if="index<=9">
                  {{index}}、{{item.title}}
                  </p>
                </div>
              </div>
              <div class="huida"  v-for="(itm,index) in Mylist" :key="index">
                <div class="top_right" v-if="itm.state=='1'">
                  <div>
                        {{itm.title}}
                  </div>
                  <img src="@/assets/user.png" alt="">
                </div>
                <div class="top_left" v-if="itm.state=='2'">
                  <img src="@/assets/logo2.png" alt="">
                  <div>
                        <div @click="imageChagange($event)" v-html="itm.title"  ></div>
                        <p v-for="(items,idx) in itm.keywords" :key="idx" class="lint" @click="keywod_btns(items)">{{items}}</p>
                  </div>
                </div>
              </div>
          </div>
        </div>
        <div class="line_border"></div>
        <div class="bottom">
            <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 3}" v-model="pint.keywords" @keyup.enter.native="send"></el-input>
            <div class="guan" @click="lineClose">关闭</div>
            <div class="fa" @click="send">发送</div>
        </div>
      </div>
    </el-dialog>
    <el-image-viewer
        v-if="showViewer"
        :on-close="closeViewer"
        :url-list="[url1]"
    />
    <el-dialog :close-on-click-modal="false"
      title="短信充值"
      :visible.sync="smsFlow"
      :before-close="smsClose"
      width="42%"
      center
    >
      <el-divider></el-divider>
      <el-form ref="form" :model="form1" label-width="80px">
            <div class="itemOne">
              <el-form-item label="计费类型:">
                <el-input v-model="charge_des" placeholder="计费类型" disabled></el-input>
              </el-form-item>
              <div>
                <el-form-item label="单价:">
                  <span>{{charge_price}}</span>
                </el-form-item>
              </div>
              <div class="charge">
                <el-form-item label="当前余额:" >
                  <el-input v-model="Balance" disabled placeholder="当前余额">
                      <template slot="append">元</template> 
                  </el-input>
                </el-form-item>
              </div>
            </div>
            <div class="itemTwo">
              <el-form-item label="充值金额:" v-if="type=='1'">
                <el-input v-model="price" placeholder="充值金额"  @change="inputPrice">
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
              <el-form-item label="充值天数:" v-if="type=='2'">
                <el-input v-model="price" placeholder="充值天数" @change="inputPrice">
                  <template slot="append">天</template>
                </el-input>
              </el-form-item>
              <el-form-item label="合计:">
                <el-input v-model="form1.chargeBal" disabled>
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
            </div>
            <el-form-item label="支付方式:">
              <el-radio-group v-model="form1.payMode">
                <el-radio label="2">微信支付</el-radio>
                <el-radio label="3">支付宝支付</el-radio>
                <el-radio label="4">汇款支付</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item class="btn">
              <el-button @click="clearCh">清空</el-button>
              <el-button class="btnL" @click="Recharge">确认提交</el-button>
            </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false"  
      title="汇款支付"
      :visible.sync="remittance"
      :before-close="remiHandleClose"
      width="40.8%"
      center
    >
      <el-divider></el-divider>
      <el-form>
        <div class="mayMode">
          <div>收款方信息</div>
          <div>
            <div>
              <el-descriptions :column="1" direction="vertical">
                <el-descriptions-item label="收款账户">{{remi.jfyName}}</el-descriptions-item>
                <el-descriptions-item label="收款方开户行">{{remi.jfyAccountBank}}</el-descriptions-item>
                <el-descriptions-item label="收款方账户">{{remi.jfyAccount}}</el-descriptions-item>
              </el-descriptions>
              <!-- <div class="remiFlex">
                <span>收款账户：</span> <span>{{remi.jfyName}}</span>
                <span>收款方开户行：</span> <span>{{remi.jfyAccountBank}}</span>
                <span>收款方账户：</span> <span>{{remi.jfyAccount}}</span>
              </div> -->
            </div>
            <div>
              <span>注:</span>
              <span>您需要汇款--元至下一账户,汇款成功后上传凭证信息,审核通过后到账.</span>
            </div>
          </div>
        </div>
        <div class="fukuanfang">付款方信息</div>
        <div class="itemFour">
          <div>
            <el-form-item label="付款户名:">
              <el-input  v-model="formremi.remitName" placeholder="请输入付款户名"></el-input>
            </el-form-item>
            <el-form-item label="付款账户:">
              <el-input  v-model="formremi.remitCode" placeholder="请输入付款账户"></el-input>
            </el-form-item>
            <el-form-item label="付款时间:">
              <el-date-picker
                v-model="formremi.remitDate"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="付款凭证:">
              <el-upload class="avatar-uploader" action="http://xwt.softykt.net/api/scenic/uploadRemitImg" :show-file-list="false"
                  :on-success="handlePreviewVide" :data="headers">
                  <i slot="default" class="el-icon-plus" v-if="formremi.remitImg==''"></i>
                  <div v-else>
                    <img class="el-upload-list__item-thumbnail" :src="formremi.remitImg" alt />
                  </div>
              </el-upload>
              <div class="zhu">
                <span style="margin-right:10px">注:</span>
                <span>付款凭证图片,支持jpg,jpeg.png格式,图片不超过5MB</span>
              </div>
            </el-form-item>
          </div>
        </div>
        <el-form-item class="btnS">
          <el-button class="btnL" @click="remiClick">确认提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <div v-show="Visible" class="mask">
        <div class="mask_box">
          <div class="mask_title">
             微信扫码支付
             <img src="@/images/distributor/Grou.png" alt="" @click="closeFlag">
          </div>
          <div class="qrcode" ref="qrCodeUrl" id="qrcode"></div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="closeFlag">取 消</el-button>
            <el-button type="primary" @click="payment">确 定</el-button>
          </span>
        </div>
    </div>

    <el-dialog
      :close-on-click-modal="false"
      :title="balanceDialogVisible ? '余额不足提醒' : '服务到期提醒'"
      :visible.sync="isShowDialog"
      :before-close="handleRemindLater"
      width="35%"
      center
    >
      <el-divider></el-divider>
      
      <div class="contact-dialog-content">
        <!-- 提示图标 -->
        <div class="dialog-icon">
          <img 
            v-if="balanceDialogVisible" 
            src="@/assets/warning-balance.png" 
            alt="余额不足"
            style="width: 80px; height: 80px;"
          >
          <img 
            v-else 
            src="@/assets/warning-time.png" 
            alt="时间过期"
            style="width: 80px; height: 80px;"
          >
        </div>
        
        <!-- 提示标题 -->
        <div class="dialog-title">
          {{ balanceDialogVisible ? '短信服务费余额不足' : '短信服务费已到期或即将到期' }}
        </div>
        
        <!-- 提示消息 -->
        <div class="dialog-message">
          <div v-if="balanceDialogVisible">
            <p>您的短信服务费余额剩于 <span class="highlight-text">{{ scenicbalance }}</span> 元</p>
            <!-- <p>余额不足将影响短信发送功能</p> -->
          </div>
          <div v-else>
            <p>您的短信服务费于 <span class="highlight-text">{{ scenicbalance }}</span> 到期</p>
            <!-- <p>到期后将无法使用短信发送功能</p> -->
          </div>
        </div>
        
        <!-- 联系客服信息 -->
        <div class="contact-info">
          <div class="contact-title">
            <i class="el-icon-phone-outline"></i>
            请联系客服进行充值/续费
          </div>
          
          <div class="phone-numbers">
            <div class="phone-item">
              <span class="phone-label">客服电话：</span>
              <div class="phone-content">
                <span class="phone-number">15611477385</span>
              </div>
            </div>
            <div class="dialog-actions">
              <el-button 
                class="remind-later-btn" 
                @click="handleRemindLater"
              >
                稍后处理
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import print from 'vue-print-nb'
import {GetScenicOrderCount,GetScenicNewMailList,SencicPrintMss,Ticket,getScenicNewMailInfo,
  getServiceList,getSuperAdminNotice,ScenicSMSstatistics, SMSstatistics,
  readStateChange , GetSMStopup , PaySMS , SetSMStopup , getPayInfo , remitApi , ScenicMessage } from '@/request/scenic.js'
import { Message } from 'element-ui';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
import QRCode from 'qrcodejs2'
export default {
  directives: {
      print   
  },
  components: {
    	ElImageViewer
  },
  data() {
    return {
      Visible:false,
      headers:{
        token:window.sessionStorage.getItem('Token'),
      },
      remi:{
        jfyAccount:'',
        jfyAccountBank:'',
        jfyName:''
      },
      remittance:false,
      formremi:{
        token:window.sessionStorage.getItem('Token'),
        remitName:'',
        remitCode:'',
        remitDate:'',
        remitImg:'',
        payid:''
      },
      form1: {
        token:window.sessionStorage.getItem('Token'),
        type:'1',
        chargeTime:'',
        payMode:'2',
        chargeBal:'',
        qfBal:'',
      },
      price:'',
      type:'',
      charge_des:'',
      Balance:'',
      charge_price:'',
      commission:'',
      qf_Balance:'',
      qf_account:'',
      smsFlow:false,
      url1:'',
      showViewer:false,
      lineFlow:false,
      ruleForm: {
          name:'',
      },
      noticeFlow:false,
      infoDialogVisible:false,
      value: new Date(),
      tableData: [
      ],
      form: {
        name: ""
      },
      noteDialogVisible: false, // 订单详情
      printDialogVisible: false, // 小票打印预览
      value: new Date(),
      ulNote: [
      ],
      navList: [
        {
          id: 2,
          title: "昨日订单数量",
          navTotal: 0,
          srcUrl: require("../../images/scenic/dxgl.png"),

          unit: "单"
        },
        {
          id: 3,
          title: "昨日订单核销",
          navTotal: 0,
          srcUrl: require("../../images/scenic/dxgl.png"),

          unit: "单"
        },
        {
          id: 4,
          title: "昨日退单",
          navTotal: 0,
          srcUrl: require("../../images/scenic/dxgl.png"),
          unit: "单"
        }
      ],
      data:{
        token:window.sessionStorage.getItem('Token'),
        page_size:5,
        page:1
      },
      code:'',
      noteList:'',
      order_detail:[],
      price1:'',
      multipleSelection: [],
      printOption: {
					id: 'nbprint', // 打印元素的id 不需要携带#号
					preview: true, // 开启打印预览
          standard:'HTML',
          targetStyles: ["*"],
					previewBeforeOpenCallback: () => {
						console.log("触发打印预览打开前回调");
					},
					previewOpenCallback: () => {
						console.log("触发打开打印预览回调");
					},
					beforeOpenCallback: () => {
						console.log("触发打印工具打开前回调");
					},
					openCallback: () => {
						console.log("触发打开打印工具回调");
					},
					closeCallback: () => {
						console.log("触发关闭打印工具回调");
					},
					clickMounted: () => {
						console.log("触发点击打印回调");
					}
			},
      pint:{
        token:window.sessionStorage.getItem("Token"),
        page:1,
        page_size:99,
        title:'',
        keywords:'',
        cs_id:''
      },
      list:[],
      Mylist:[],
      notice:{},
      scenicbalance:'',
      charge:'',
      flow:false,
      flow1:false,
      is_id:'',
      balanceDialogVisible: false,    // 余额不足弹窗控制
      timeExpiredDialogVisible: false, // 时间过期弹窗控制
      dialogMessage: '',               // 弹窗提示消息
      isShowDialog: false,             // 是否显示提示弹窗
      currentBalance: 0,               // 当前余额
      currentExpiryDate: '',           // 过期时间
      customerServicePhone: '15611477385', // 客服电话
    }
  },
  created(){
    let data = {
      token:window.sessionStorage.getItem('Token'),
    }
    getSuperAdminNotice(data).then(res=>{
      if(res.data.status=='ok'){
        this.noticeFlow = true
        this.notice = res.data.data
      }
    })
    if(window.sessionStorage.getItem('index')!=1){
      // 景区充值弹框
      ScenicMessage(data).then(res=>{
            if(res.data.status=='ok'){
              window.sessionStorage.setItem('is_id',res.data.result.Status)
              this.is_id = window.sessionStorage.getItem('is_id')
              SMSstatistics(data).then(res=>{
                if(res.data.status=='ok'){
                  this.charge = res.data.result.charge
                  ScenicSMSstatistics(data).then(resn=>{
                  if(resn.data.status=='ok'){
                    if(resn.data.status == 'ok') {
                      console.log(this.charge)
                    if(this.charge == '2') {
                      // 计时模式
                      this.currentExpiryDate = resn.data.result.scenicbalance.split('→')[1]
                      this.scenicbalance = this.currentExpiryDate
                      
                      // 检查是否过期
                      this.checkExpiryDate(this.currentExpiryDate)
                    } else {
                      // 计费模式
                      this.currentBalance = parseFloat(resn.data.result.scenicbalance)
                      this.scenicbalance = this.currentBalance
                      
                      // 检查余额是否不足
                      this.checkBalance(this.currentBalance)
                    }
                  }
                    // if(this.charge=='2'){
                    //   let num = Date.parse(new Date()) 
                    //   let newtime =  Date.parse(new Date(resn.data.result.scenicbalance.split('→')[1] + ' 23:59:59'))  
                    //   if(newtime<num){
                    //     this.flow1 = true
                    //   }else{
                    //     this.flow1 = false
                    //   }
                    // }else{
                    //   if(resn.data.result.scenicbalance<=0){
                    //     this.flow1 = true
                    //   }else{
                    //     this.flow1 = false
                    //   }
                    // }
                  }
                })
              }
            })
            }
          })
    }
    
    this.getList()
    this.SMSList()
  },
  methods: {
    // 稍后处理
    handleRemindLater() {
      this.isShowDialog = false
      this.balanceDialogVisible = false
      this.timeExpiredDialogVisible = false
    },
    // 检查余额是否不足（计费模式）
    checkBalance(balance) {
      // 假设余额小于10元时提示
      const minBalance = 10
      
      if (balance < minBalance) {
        this.isShowDialog = true
        this.balanceDialogVisible = true
      }
    },
    
    // 检查是否过期（计时模式）
    checkExpiryDate(expiryDate) {
      const now = new Date()
      const expiry = new Date(expiryDate)
      
      // 如果已经过期
      if (expiry < now) {
        this.isShowDialog = true
        this.timeExpiredDialogVisible = true
      } else {
        // 计算剩余天数
        const timeDiff = expiry.getTime() - now.getTime()
        const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24))
        
        // 如果剩余天数小于7天，也提示
        if (daysDiff <= 7 && daysDiff > 0) {
          this.isShowDialog = true
          this.timeExpiredDialogVisible = true
        }
      }
    },
    kaitong(){
      this.$router.push('/cooperation')
    },
    payment(){
      this.Visible = false
    },
    closeFlag(){
      this.Visible = false
    },
    remiClick(){
      remitApi(this.formremi).then(res=>{
        if(res.data.status=='ok'){
          this.remittance = false
          Message.success('提交成功')
          this.formremi.remitImg = ''
          this.formremi.payid = ''
          this.remi.jfyAccount = ''
          this.remi.jfyAccountBank = ''
          this.remi.jfyName = ''
        }else{
          Message.error(res.data.msg)
        }
      })
    },
    clearCh(){
      this.price = ''
      this.form.chargeBal = ''
    },
    remiHandleClose(){
      this.remittance = false
      this.formremi.remitImg = ''
      this.formremi.payid = ''
      this.remi.jfyAccount = ''
      this.remi.jfyAccountBank = ''
      this.remi.jfyName = ''
    },
    handlePreviewVide(res){
      this.formremi.remitImg = res.result
    },
    Recharge(){
      if(this.form1.chargeBal==''||this.form1.chargeBal==0){
        Message.error('请输入充值金额')
        return false
      }
      SetSMStopup(this.form1).then(res=>{
        if(res.data.status=='ok'){
          if(this.form1.payMode=='4'){
            let data = {
              token:window.sessionStorage.getItem('Token'),
            }
            getPayInfo(data).then(ren=>{
              if(ren.data.status=='ok'){
                this.formremi.payid = res.data.result
                this.remi.jfyAccount = ren.data.data.jfyAccount
                this.remi.jfyAccountBank = ren.data.data.jfyAccountBank
                this.remi.jfyName = ren.data.data.jfyName
              }
            })
            this.remittance =  true
            return false
          }
          let data = {
            token:window.sessionStorage.getItem('Token'),
            payid:res.data.result,
            scenicid:window.sessionStorage.getItem('ScenicId')
          }
          PaySMS(data).then(respone=>{
            if(respone.data.status=='ok'){
              // respone.data.result
              console.log(this.form1.payMode)
              if(this.form1.payMode=='2'){
                document.getElementById("qrcode").innerHTML = ''
                this.Visible = true
                this.creatQrCode(respone.data.result)
              }else if(this.form1.payMode=='3'){
                // document.write(respone.data.result)
                let divForm = document.getElementsByTagName('divform')
                if (divForm.length) {
                  document.body.removeChild(divForm[0])
                }
                const div = document.createElement('divform')
                div.innerHTML = respone.data.result // res.data就是sb支付宝返回给你的form
                document.body.appendChild(div)
                document.getElementById('alipaysubmit').target="_blank"
                document.getElementById('alipaysubmit').submit()
                MessageBox('充值完成?')
                .then(_ => {
                })
                .catch(_ => {});
              }
            }
          })
        }
      })
    },
    creatQrCode(img){
      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
            text: img, // 需要转换为二维码的内容
            width: 150,
            height: 150,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: QRCode.CorrectLevel.H
        })
    },
    inputPrice(){
      if(this.type=='1'){
        // 计费
        this.form1.chargeBal = this.price
        // this.hairMon = this.hairMoney
      }else{
        //  计时
        this.form1.chargeTime = this.price
        this.form1.chargeBal = this.price * this.commission
        // this.hairMonTime =  this.hairMoney 
        // this.hairMon =  this.hairMoney * this.commission
      }
    },
    smsClose(){
      this.smsFlow = false
      this.price = ''
      this.form1.chargeBal = ''
    },
    toastClick(){
      let data = {
        token:window.sessionStorage.getItem('Token'),
      }
      GetSMStopup(data).then(res=>{
        if(res.data.status=='ok'){
          this.smsFlow = true
          this.type = res.data.result.charge
          this.charge_des = res.data.result.charge_des
          this.Balance = res.data.result.balance
          this.charge_price = res.data.result.charge_price
          this.commission = res.data.result.commission
          this.qf_Balance = res.data.result.qf_price
          this.qf_account = res.data.result.qf_account
        }
      })
    },
    closeViewer(){
      this.showViewer = false
      this.url1 = ''
    },
    imageChagange(e){
      if (e.target.nodeName === 'IMG'|| e.target.nodeName == 'img') { //判断是否图片标签
        const img = e.target.currentSrc //获取点击图片地址
        this.url1 = img
        this.showViewer = true
      }
    },
    lineClose(){
      this.lineFlow = false
    },
    keywod_btns(itm){
      let data = {
        token:window.sessionStorage.getItem('Token'),
        title:itm
      }
      getServiceList(data).then(res=>{
        if(res.data.status=='ok'){
          this.Mylist.push({
            title:itm,
            state:1
          })
          this.$nextTick(function(){
            var p = this.$refs.dialogue;
            p.scrollTop = p.scrollHeight;
          })
          let keys = []
          res.data.result.data.map(item=>{
            this.list.map(items=>{
              if(item.cs_id){
                item.cs_id.split(',').map(imli=>{
                    if(imli==items.id){
                      keys.push(items.title)
                    }
                })
              }
            })
          })
          this.Mylist.push({
            title:res.data.result.data[0].content,
            state:2,
            keywords:keys
          })
          this.$nextTick(function(){
            var p = this.$refs.dialogue;
            p.scrollTop = p.scrollHeight;
          })
        }
      })
    },
    getTimes(timeStamp){
      var now = new Date(timeStamp),
        y = now.getFullYear(),
        m = ("0" + (now.getMonth() + 1)).slice(-2),
        d = ("0" + now.getDate()).slice(-2),
        hh = ("0" + now.getHours()).slice(-2),
        mm = ("0" + now.getMinutes()).slice(-2),
        ss = ("0" + now.getSeconds()).slice(-2);
        console.log(y + "-" + m + "-" + d + " " + hh + ':' + mm + ":" + ss)
        return y + "-" + m + "-" + d + " " + hh + ':' + mm + ":" + ss;
    },
    noticeBtns(){
      let data = {
        token:window.sessionStorage.getItem('Token'),
        noticeid:this.notice.id,
        state:2
      }
      readStateChange(data).then(res=>{
        if(res.data.status=='ok'){
          Message.success('操作成功')
          this.noticeFlow = false
          this.notice = '' 
        }
      })
    },
    send(){
      if(this.pint.keywords==''){
        Message.error('请输入')
        return false
      }
      this.Mylist.push({
        title:this.pint.keywords,
        state:1
      })
      this.$nextTick(function(){
        var p = this.$refs.dialogue;
        p.scrollTop = p.scrollHeight;
      })
      this.sendList()
      this.pint.keywords = ''
    },
    sendList(){
      getServiceList(this.pint).then(res=>{
        if(res.data.rcode==200){
          if(res.data.result.data.length==0){
            this.Mylist.push({
              title:'查询条件不匹配',
              state:2
            })
            this.$nextTick(function(){
              var p = this.$refs.dialogue;
              p.scrollTop = p.scrollHeight;
            })
            return false
          }
          this.Mylist.push({
            title:res.data.result.data[0].content,
            state:2
          }) 
          this.$nextTick(function(){
            var p = this.$refs.dialogue;
            p.scrollTop = p.scrollHeight;
          })
         
        }
      })
    },
    listBtns(item){
      this.Mylist.push({
        title:item.title,
        state:1
      })
      this.$nextTick(function(){
        var p = this.$refs.dialogue;
        p.scrollTop = p.scrollHeight;
      })
      setTimeout(() => {
        if(item.keywords_flag=='2'){
          let data = {
            token:window.sessionStorage.getItem("Token"),
            page:1,
            page_size:99,
            title:'',
            keywords:'',
            cs_id:''
          }
          let keys = []
          getServiceList(data).then(res=>{
            if(res.data.status=='ok'){
              item.cs_id.split(',').map(itms=>{
                res.data.result.data.map(im=>{
                    if(im.id==itms){
                      keys.push(im.title)
                    }
                })
              })
            }
          })
          this.Mylist.push({
            title:item.content,
            keywords:keys,
            state:2
          })
        }else{
          this.Mylist.push({
            title:item.content,
            state:2
          })
        }
        
        // let keys = item.keywords.split('，')
        // this.Mylist.push({
        //   title:item.content,
        //   keywords:keys,
        //   state:2
        // })
        this.$nextTick(function(){
          var p = this.$refs.dialogue;
          p.scrollTop = p.scrollHeight;
        })
      }, 1000);
     
    },
    zixun(){
      this.lineFlow = true
      this.serverList()
    },
    serverList(){
      getServiceList(this.pint).then(res=>{
        if(res.data.rcode==200){
          this.list =  res.data.result.data
        }
      })
    },
    lineClose(){
      this.lineFlow = false
    },
    noticeClose(){
      this.noticeFlow = false
      this.notice = ''
    },
    goRecharge(){
      this.$router.push({
        path:'noteSta',
        query:{
          id:'1'
        }
      })
    },
    infoFn(row) {
      this.infoDialogVisible = true;
      this.form.value1 = row.CreateTime
      let data = {
        token:window.sessionStorage.getItem('Token'),
        NewMailID:row.NewMailID
      }
      getScenicNewMailInfo(data).then(res=>{
        if(res.data.rcode==200){
          this.form.name = res.data.result.FromUserID=='1'?'金飞鹰系统':'系统'
          this.form.content = res.data.result.MailContent
        }
      })
    },
    infoHandleClose(){
      this.infoDialogVisible = false
    },
    // 打印
    checkprint(){
      console.log(this.noteList)
      this.noteList.order_detail.map(item=>{
          if(item.CountUse!=0){
            this.printDialogVisible = true
          }
      })
    },
    handleSelectionChange(val) {
        this.multipleSelection = val;
    },
    whole(){
      this.$router.push('/allMsgs')
    },
    // 数据统计
    getList(){
      let data = {
        token:window.sessionStorage.getItem('Token'),
      }
      GetScenicOrderCount(data).then(res=>{
        if(res.data.status=='yes'){
          this.navList[0].navTotal = res.data.result.yesterday_order_count
          this.navList[1].navTotal = res.data.result.yesterday_order_usecount
          this.navList[2].navTotal = res.data.result.yesterday_order_refund
        }
      })
    },
    // 短信列表
    SMSList(){
      GetScenicNewMailList(this.data).then(res=>{
        if(res.data.rcode==200){
          this.ulNote = res.data.result.data
        }
      })
    },
    // 小票打印预览
    checkTicFn() {
      if(this.multipleSelection.length==0){
        Message.error('请选择产品')
        return false
      }
      let use = 0
      console.log(this.multipleSelection)
      this.multipleSelection.map(item=>{
        if(item.state){
          use += Number(item.state)
        }else{
          use += 0
        }
      })
      if(use==0){
        Message.error('请输入验票数量')
        return false
      }
      let data = {
        token:window.sessionStorage.getItem('Token'),
        code:this.code,
        use:use + '',
        offlineUID:''
      }
      Ticket(data).then(res=>{
        if(res.data.rcode=='200'){
          this.noteDialogVisible = false;
          this.$message.success('验票成功')
        }else{
          Message.error(res.data.msg)
        }
      })
      // 
      // this.printDialogVisible = true;
    },
    // 小票打印预览X
    printHandleClose() {
      this.printDialogVisible = false;
    },
    // 订单详情
    detailFn() {
      this.order_detail = []
      if(this.code==''){
        this.$message.error('验证码为空')
        return false
      }
      let data = {
        code:this.code,
        token:window.sessionStorage.getItem('Token'),
      }
      SencicPrintMss(data).then(res=>{
        if(res.data.status=='ok'){
          this.noteList = res.data.result
          res.data.result.order_detail.map(item=>{
            this.order_detail.push(item.OrderAll)
            this.order_detail.map(itm=>{
              itm.CountUse = item.CountUse
            })
            this.price1 = Number(item.OrderAll.agentprice) * this.noteList.Count
          })
         
          this.noteDialogVisible = true;
        }else{
          Message.error(res.data.msg)
        }
      })
    },
    // 订单详情X
    noteHandleClose() {
      this.noteList = ''
      this.order_detail= []
      this.noteDialogVisible = false;
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang='less' scoped>
.is-selected {
  width: 24px;
  height: 24px;
  background: #246deb;
  border-radius: 4px;
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  text-align: center;
  color: #ffffff;
}
/deep/.el-calendar-table tr:first-child td {
  border: none;
}
/deep/.el-calendar-table .el-calendar-day {
  box-sizing: border-box;
  padding: 0px;
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #000000;
}
/deep/.el-calendar__header {
  display: flex;
  justify-content: space-between;
  padding: 0px;
  border-bottom: 1px solid #ebeef5;
  width: 98%;
}
/deep/.el-calendar__header {
  display: flex;
  justify-content: space-between;
  padding: 0px;
  border-bottom: 0px solid #ebeef5;
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: #000000;
}
/deep/.el-calendar-table td {
  border: none;
  vertical-align: top;
  transition: background-color 0.2s ease;
}
/deep/.el-button--mini {
  font-size: 12px;
  border-radius: 3px;
  border: none;
}
/deep/.el-button-group > .el-button:first-child {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  color: #246deb;
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  background-color: transparent !important;
}
/deep/.el-button-group > .el-button:last-child {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  color: #246deb;
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  background-color: transparent !important;
}
/deep/.el-button-group > .el-button:not(:first-child):not(:last-child) {
  margin-left: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  color: #ffffff;
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  background: #246deb;
}

/deep/.el-calendar__body {
  width: 105%;
  padding: 10px;
}
/deep/.el-calendar-table td.is-selected {
  width: 24px;
  height: 24px;
  background-color: transparent !important;
}
/deep/.el-calendar-table tr td:first-child {
  border-left: none;
}

.btn {
  display: flex;
  justify-content: center;
  margin: 40px 0 30px 0;
  /deep/.el-button {
    width: 100px;
    border: 1px solid #246deb;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #246deb;
    background: #ffffff;
  }
}
.conentCenter {
  margin: 0;
  .printContent {
    background: url(../../images/scenic/xpyl.png) no-repeat;
    // width:40rem;
    padding: 10px 20px;
    box-sizing: border-box;
    margin: auto;
    background-size: 100% 100%;
    // border: 1px double #246deb;
    // position: absolute;
    // top: 82px;
    // left: 41px;
    > div:nth-child(1) {
      height: 64px;
      line-height: 64px;
      text-align: center;
      font-family: "OPPOSans";
      font-style: normal;
      font-size: 18px;
      /* identical to box height */
      color: #000000;
      border-bottom: 2px double #c4c4c4;
    }
    > div:nth-child(2) {
      margin-top: 18px;
      /deep/.el-descriptions :not(.is-bordered) .el-descriptions-item__cell {
        padding-bottom: 15px;
      }
      /deep/.el-descriptions-item__label {
        font-family: "OPPOSans";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 18px;
        text-align: right;

        color: #666666;
      }
      /deep/.el-descriptions-item__content {
        font-family: "OPPOSans";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 18px;

        color: #000000;
      }
    }
    > div:nth-child(3) {
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #e74c3c;
      margin: 10px 0 20px 0;
    }
  }
}
.btns {
  margin-top: 40px;
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
  .el-button {
    width: 100px;
    height: 40px;
    box-sizing: border-box;
    background: #ffffff;
    border: 1px solid #246deb;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    text-align: center;

    color: #246deb;
  }
  .btnL {
    background: #246deb;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    text-align: center;

    color: #ffffff;
  }
}
.formItem {
  display: flex;
  flex-wrap: wrap;
  .el-form-item {
    display: flex;
    margin-right: 12px;
  }
  .three {
    // width: 257px;
    /deep/.el-form-item__label {
      width: 59px;
      text-align: left;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 40px;
      text-align: right;
      color: #666666;
    }
    /deep/.el-input {
      width: 200px;
    }
  }
  .four {
    /deep/.el-form-item__label {
      width: 92px;
      text-align: left;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 40px;
      text-align: right;
      color: #666666;
    }
    /deep/.el-input {
      width: 180px;
    }
  }
}
.formItems {
  /deep/.el-form-item__label {
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: right;
    color: #666666;
  }
  .itemOne {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .el-input {
      width: 215px;
    }
  }
  .itemBtn {
    display: flex;
    justify-content: center;
    margin-left: -80px;
    margin-top: 40px;
    margin-bottom: 0px;
    .btnL {
      width: 110px;
      border: none;
      background: #246deb;
      border-radius: 4px;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
    }
  }
}
.card {
  margin-top: 2rem;
  .cardDiv {
    display: flex;
    > div:nth-child(1) {
      min-width: 580px;
      width: 121rem;
      height: 44.1rem;
      margin-right: 20px;
      padding: 0 20px 20px 20px;
      box-sizing: border-box;
      background: #ffffff;
      border-radius: 4px;
      > div:nth-child(1) {
        width: 100%;
        height: 59px;
        border-bottom: 1px solid #e5e5ea;
        display: flex;
        justify-content: space-between;
        align-items: center;
        > span:nth-child(1) {
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 20px;
          line-height: 28px;
          /* identical to box height */

          color: #000000;
        }
        > span:nth-child(2) {
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          /* identical to box height */

          color: #246deb;
        }
      }
      .ul {
        > li {
          width: 100%;
          height: 50px;
          max-height: auto;
          margin: 20px 0;
          padding: 20px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          background: #ffffff;
          border: 1px solid #e5e5ea;
          border-radius: 4px;
          > div:nth-child(1) {
            width: 85%;
            > span:nth-child(2) {
              display: inline-block;
              margin: 0 28px;
              font-family: ".PingFang SC";
              font-style: normal;
              font-weight: 400;
              font-size: 14px;
              line-height: 20px;
              /* identical to box height */
              color: #000000;
            }
            > span:nth-child(3) {
              display: inline-block;
              margin-right: 28px;
              font-family: ".PingFang SC";
              font-style: normal;
              font-weight: 400;
              font-size: 14px;
              line-height: 20px;
              /* identical to box height */

              color: #000000;
            }
            > span:nth-child(4) {
              display: inline-block;
              //   margin: 0 28px;
              font-family: ".PingFang SC";
              font-style: normal;
              font-weight: 400;
              font-size: 14px;
              line-height: 20px;
              /* identical to box height */
              color: #666666;
            }
          }
          > div:nth-child(2) {
            width: 15%;
            text-align: right;
          }
        }
        > div:nth-child(2) {
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          /* identical to box height */

          color: #000000;
        }
      }
    }
    .cardRight {
      width: 24%;
      height: 44.1rem;
    
      > div:nth-child(1) {
        height: 100%;
        min-width: 200px;
        width: 100%;
        background: #ffffff;
        border-radius: 4px;
        padding: 0 20px 20px 20px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        > div:nth-child(1) {
          width: 100%;
          height: 62px;
          line-height: 62px;
          border-bottom: 1px solid #e5e5ea;
          font-family: "OPPOSans";
          font-style: normal;
          font-weight: 400;
          font-size: 20px;
          color: #000000;
          display: flex;
          align-items: center;
        }
        > div:nth-child(2) {
          flex: 1;
          margin-top: 10px;
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          img{
            width: 195px;
            height: 195px;
          }

        }
       
      }
    }
  }
}
.navFrame {
  width: 100%;
  display: flex;
  margin: 17px 0;
  .navDataBig {
    width: 100%;
    display: flex;
    flex-wrap:wrap ;
    > div {
      margin-bottom: 1rem;
      width: 39rem;
      min-width:280px;
      height: 150px;
      background: #ffffff;
      border-radius: 4px;
      margin-right: 20px;
      > div:nth-child(1) {
        width: 84px;
        height: 20px;
        margin-left: 20px;
        margin-top: 17px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        /* identical to box height */

        color: #666666;
      }
      > div:nth-child(2) {
        height: 56px;
        display: flex;
        margin-top: 40px;
        // background: red;
        img {
          width: 80px;
          height: 60px;
          margin-right: 20px;
        }
        span {
          width: 100%;
          margin-bottom: 20px;
          display: flex;
          > span:nth-child(1) {
            display: block;
            width: 120px;
            height: 100%;
            line-height: 100px;
            margin-left: 21px;
            margin-right: 8px;
            font-family: ".PingFang SC";
            font-style: normal;
            font-weight: 600;
            font-size: 40px;
            line-height: 56px;
            /* identical to box height */
            color: #246deb;
          }
          > span:nth-child(2) {
            display: block;
            width: 20px;
            height: 100%;
            margin-top: 20px;
            font-family: ".PingFang SC";
            font-style: normal;
            font-weight: 400;
            font-size: 20px;
            line-height: 28px;
            /* identical to box height */
            color: #797979;
          }
        }
      }
    }
  }
}
/deep/.el-dialog__header {
  height: 60px;
  line-height: 60px;
  padding: 0;
}

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
.cssWhole{
  cursor: pointer;
}
.print_l{
  display: flex;
  margin-bottom: 1.5rem;
  span{
    &:nth-child(1){
      width: 7rem;
      color: #666;
      font-size: 1.4rem;
      display: block;
      text-align: right;
    }
    &:nth-child(2){
      margin-left: 0.2rem;
      color: #000;
      font-size: 1.4rem;
    }
  }
}
.print_ri{
  div{
    margin-bottom: 1.5rem;
    display: flex;
    span{
      &:nth-child(1){
        width: 8rem;
        color: #666;
        font-size: 1.4rem;
        display: block;
        text-align: right;
      }
      &:nth-child(2){
        margin-left: 0.2rem;
        color: #000;
        font-size: 1.4rem;
      }
    }
  }
}
.pro_order{
  color: #E74C3C;
}
/deep/ .el-dialog{
  min-width: 400px;
}
.ticket_input /deep/.el-input{
  width: 10rem;
  border-radius: 0.4rem;
  background: #F7F7FA;
}
.formItem /deep/ input{
  background: #fff !important;
  color: #666 !important;
}
/deep/.el-calendar__button-group{
  display: none;
}
.wendang{
  width: 100%;
  height: 31.4rem;
  display: flex;
  align-items: center;
  >div:nth-child(1){
    width: 121rem;
    height: 100%;
    background: #fff;
    border-radius: 0.4rem;
    display: flex;
    flex-direction: column;
    .dang_title{
      padding: 1.7rem 2rem;
      border-bottom: 1px solid #E5E5EA;
      box-sizing: border-box;
      span{
        font-size: 2rem;
        &:nth-child(1){
          color: #000000;
        }
        &:nth-child(2){
          display: block;
          margin-left: 2rem;
        }
      }
    }
    .wen_boxs{
      padding: 0 2rem;
      box-sizing: border-box;
      flex: 1;
      overflow-y: auto;
      display: flex;
      flex-wrap: wrap;
      >div{
          width: 33%;
          padding: 2.2rem 0;
          box-sizing: border-box;
          border-bottom: 1px solid #E5E5EA;
          display: flex;
          // justify-content: space-between;
          align-items: center;
          cursor: pointer;
          >span{
            display: block;
            margin-left: 2rem;
            color: red;
          }
        >a{
          
          &:last-child{
            border: 0;
          }
          span{
            color: #000000;
            font-size: 1.4rem;
          }
        }
      }
    }
  }
  >div:nth-child(2){
   flex: 1;
    height: 100%;
    margin-left: 2rem;
    >div{
      width: 100%;
      height: 14.7rem;
      background: #fff;
      border-radius: 0.4rem;
      display: flex;
      flex-direction: column;
      &:nth-child(2){
        margin-top: 2rem;
      }
      .dang_title{
        padding: 1.7rem 2rem;
        border-bottom: 1px solid #E5E5EA;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        span{
          font-size: 2rem;
          &:nth-child(1){
            color: #000000;
          }
          &:nth-child(2){
            flex:1;
            display: block;
            font-size: 1.6rem;
            margin-left: 2rem;
          }
        }
      }
      .dang_btns{
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        div{
          width: 31rem;
            height: 4.7rem;
            border-radius: 0.4rem;
            background: #246deb;
            font-size: 1.4rem;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;
            cursor: pointer;
        }
      }
    }
  }
}
::v-deep .el-dialog__headerbtn {
  top: 7px;
  .el-icon-close{
    font-size: 3rem;
  }
}
.noticeClass{
  >div:nth-child(1){
    width: auto;
    min-height: 26rem;
    border: 1px solid #C4C4C4;
    border-radius: 0.4rem;
    position: relative;
    display: flex;
    flex-direction: column;
    padding: 2rem;
    box-sizing: border-box;
    div{
      position: absolute;
      bottom: 2rem;
      right: 2rem;
      color: #797979;
      font-size: 1.4rem;
    }
    .title{
      color: #000000;
      font-size: 1.4rem;
      text-align: center;
      display: block;
    }
    .time{
      color: #797979;
      font-size: 1.4rem;
      margin-top: 1.1rem;
      text-align: center;
      display: block;
    }
    .zz{
      margin-top: 1.8rem;
      color: #000000;
      font-size: 1.4rem;
    }
    .con{
      color: #000000;
      font-size: 1.4rem;
      text-indent:2em;
      margin-bottom: 2rem;
    }
  }
  .btns_not{
    display: flex;
    margin-top: 4.8rem;
    justify-content: center;
    align-items: center;
    margin-bottom: 2rem;
    >div{
      width: 10rem;
      height: 4rem;
      border-radius: 0.4rem;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1.4rem;
      cursor: pointer;
      &:nth-child(1){
        border: 1px solid #246deb;
        color: #246deb;
      }
      &:nth-child(2){
        background: #246deb;
        color: #fff;
        margin-left: 2rem;
      }
    }
  }
}
.form_btns{
  margin-top: 4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 2rem;
  >div{
    width: 10rem;
    height: 4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #FFFFFF;
    font-size: 1.4rem;
    border-radius: 0.4rem;
    cursor: pointer;
    &:nth-child(1){
      background: #D9D9D9;
    }
    &:nth-child(2){
      background: #246deb;
      margin-left: 2rem;
    }
  }
}
.line_box{
  width: 100%;
  height: 59.1rem;
  border: 1px solid #E5E5EA;
  .top{
    height: 43.1rem;
    overflow-y: auto; 
    padding: 2rem;
    box-sizing: border-box;
    >div{
      color: #797979;
      font-size: 1.4rem;
      text-align: center;
      margin-bottom: 2rem;
    }
    .top_content{
      display: flex;
      flex-direction: column;
      .top_left{
          display: flex;
          align-items: center;
          margin-bottom: 2rem;
          img{
            width: 4rem;
            height: 4rem;
          }
          >div{
            margin-left: 1rem;
            padding: 1rem;
            border:1px solid  #E5E5EA;
            border-radius: 0.4rem;
            color: #000000;
            font-size: 1.4rem;
            p{
              text-align: left;
              color: #246DEB;
              cursor: pointer;
              margin: 0.6rem 0 0 0;
            }
          }
        }
      .huida{
        display: flex;
        .top_right{
          display: flex;
          align-items: center;
          margin-left: auto;
          margin-bottom: 2rem;
          img{
            width: 4rem;
            height: 4rem;
          }
          >div{
            padding: 1rem;
            background: #246DEB;
            border-radius: 0.4rem;
            margin-right: 1rem;
            color: #fff;
            font-size: 1.4rem;
          }
        }
        .top_left{
          display: flex;
          align-items: center;
          margin-bottom: 2rem;
          img{
            width: 4rem;
            height: 4rem;
          }
          >div{
            text-align: left;
            margin-left: 1rem;
            padding: 1rem;
            border:1px solid  #E5E5EA;
            border-radius: 0.4rem;
            color: #000000;
            font-size: 1.4rem;
            p{
              text-align: left;
              color: #246DEB;
              cursor: pointer;
            }
            ::v-deep img{
              width: 100%;
            }
          }
        }
      }
      
    }
  }
  .line_border{
    width: 100%;
    height: 0.4rem;
    background: #E5E5EA;
  }
  .bottom{
    height: 15.6rem;
    padding: 2rem;
    position: relative;
    ::v-deep .el-textarea__inner{
      height: 100% !important;
      border: none;
      resize: none;
    }
    .guan{
      width:9.6rem;
      height: 4rem;
      border: 2px solid #246DEB;
      color: #246DEB;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1.4rem;
      position: absolute;
      bottom: 2rem;
      right: 14rem;
      border-radius:0.4rem;
      cursor: pointer;
    }
    .fa{
      width: 10rem;
      height: 4rem;
      background:  #246DEB;
      color: #FFFFFF;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1.4rem;
      position: absolute;
      bottom: 2rem;
      right: 2rem;
      border-radius:0.4rem;
      cursor: pointer;
    }
  }
}
.reds{
  color: red !important;
}

.lint{
  color: #246DEB;
  margin-left: 2rem;
  cursor: pointer;
}
.mask_boxs{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  .box_content{
    width: 40rem;
    background: #fff;
    border-radius: 0.4rem;
    .title_content{
      padding: 2rem 0;
      box-sizing: border-box;
      text-align: center;
      color: #000000;
      font-size: 2rem;
      border-bottom: 1px solid #E5E5EA;
    }
    .box_content_title_box{
      padding: 2rem;
      box-sizing: border-box;
      color: #000;
      font-size: 1.4rem;
    }
    .tbns{
      width: 10rem;
      height: 4rem;
      border-radius: 0.4rem;
      background: #246DEB;
      color: #fff;
      font-size: 1.4rem;
      margin: 0 auto;
      margin-bottom: 2rem;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
  }
}
.mayMode {
      > div:nth-child(1) {
        font-family: "OPPOSans";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
      }
      > div:nth-child(2) {
        line-height: 30px;
        width: 100%;
        min-height: 190px;
        padding: 20px;
        box-sizing: border-box;
        background: #ffffff;
        border: 1px solid #e5e5ea;
        border-radius: 4px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        > div:nth-child(1) {
          width: 50%;
          /deep/.el-descriptions
            :not(.is-bordered)
            .el-descriptions-item__cell {
            padding-bottom: 4px;
          }
          /deep/.el-descriptions-item__label:not(.is-bordered-label) {
            margin-right: 10px;
            font-family: "OPPOSans";
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            color: #666666;
          }
          /deep/.el-descriptions-item__content {
            word-break: break-word;
            overflow-wrap: break-word;
            font-family: "OPPOSans";
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            color: #000000;
          }
        }
        > div:nth-child(2) {
          width: 30%;
          font-family: "OPPOSans";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          color: #e74c3c;
          > span:nth-child(1) {
            margin-right: 10px;
          }
        }
      }
    }
    .btnS {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  background: unset;
  // margin-top: 31px;
  .el-button {
    width: 100px;
    background: #d9d9d9;
    border-radius: 4px;
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
    border: none;
  }
  .btnL {
    width: 120px;
    background: #246deb;
    border-radius: 4px;
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
  }
}
/deep/ .el-upload,.el-upload img{
  width: 10rem;
  height: 7rem;
  border: 1px solid #E5E5EA;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.mask{
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .3);
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2200;
}
.mask_box{
  width: 400px;
  height: 300px;
  background: #fff;
  position: relative;
}
.mask_box /deep/ .dialog-footer{
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translate(-50%,0);
}

/deep/ .qrcode{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.mask_title{
  color: #333;
  font-size:16px;
  font-weight: 600;
  padding: 10px;
  text-align: center;
  position: relative;
}
.mask_title img{
  position: absolute;
  right: 10px;
  width: 15px;
  height: 15px;
  cursor: pointer;
}
/* 联系客服充值弹窗样式 */
.contact-dialog-content {
  padding: 20px;
  
  .dialog-icon {
    text-align: center;
    margin-bottom: 20px;
  }
  
  .dialog-title {
    font-size: 18px;
    font-weight: 600;
    color: #e74c3c;
    text-align: center;
    margin-bottom: 15px;
  }
  
  .dialog-message {
    text-align: center;
    font-size: 15px;
    color: #333;
    margin-bottom: 25px;
    line-height: 1.6;
    
    p {
      margin: 8px 0;
    }
    
    .highlight-text {
      color: #e74c3c;
      font-weight: 600;
      font-size: 16px;
    }
  }
  
  .contact-info {
    background: #f8f9fa;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 20px;
    border-left: 4px solid #246deb;
    
    .contact-title {
      font-size: 16px;
      font-weight: 600;
      color: #333;
      margin-bottom: 15px;
      display: flex;
      align-items: center;
      
      i {
        margin-right: 8px;
        color: #246deb;
      }
    }
    
    .phone-numbers {
      .phone-item {
        margin-bottom: 12px;
        
        &:last-child {
          margin-bottom: 0;
        }
        
        .phone-label {
          display: inline-block;
          width: 80px;
          font-size: 14px;
          color: #666;
        }
        
        .phone-content {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          
          .phone-number {
            font-size: 16px;
            font-weight: 600;
            color: #246deb;
          }
          
          .copy-btn {
            color: #666;
            font-size: 12px;
            
            &:hover {
              color: #246deb;
            }
          }
          
          .call-btn {
            color: #52c41a;
            font-size: 12px;
            
            &:hover {
              color: #389e0d;
            }
          }
        }
      }
    }
    
    .contact-time {
      margin-top: 15px;
      font-size: 14px;
      color: #888;
      display: flex;
      align-items: center;
      
      i {
        margin-right: 8px;
      }
    }
  }
  
  .recharge-notes {
    background: #fff7e6;
    border-radius: 8px;
    padding: 15px;
    margin-bottom: 25px;
    border: 1px solid #ffd591;
    
    .notes-title {
      font-weight: 600;
      color: #d46b08;
      margin-bottom: 10px;
      font-size: 14px;
    }
    
    .notes-content {
      p {
        margin: 6px 0;
        font-size: 13px;
        color: #874d00;
        line-height: 1.5;
        
        &:before {
          content: "•";
          margin-right: 8px;
          color: #d46b08;
        }
      }
    }
  }
  
  .dialog-actions {
    display: flex;
    justify-content: center;
    gap: 20px;
    
    .el-button {
      min-width: 120px;
      height: 40px;
      border-radius: 20px;
      font-size: 14px;
    }
    
    .remind-later-btn {
      border: 1px solid #dcdfe6;
      color: #606266;
      
      &:hover {
        border-color: #c6e2ff;
        background-color: #ecf5ff;
        color: #409eff;
      }
    }
    
    .contact-btn {
      background: #246deb;
      border: none;
      
      i {
        margin-right: 5px;
      }
      
      &:hover {
        background: #1d5bbf;
      }
    }
  }
}
</style>
<style>
 .el-image-viewer__wrapper{
  z-index: 2200 !important;
}
</style>